export const PRIMARY_COLOR_PALETTE = [
   '2f6bb3',
   '159a84',
   '606060',
   '92a5b2',
   'c96262',
   '48a267',
   'bf84d3',
   'e0bb36',
   '643674',
   '79682c',
   '3e2546',
   'f3e9c7',
   '1d4029',
] as const;
